import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import * as S from './PhonesBottomSheet.styles';
import { cleanPhoneNumber } from '@/utils/helpers';
import { PhoneIcon } from '@/components/UI/Icons/Icons';
import { BottomSheet } from '@/components/UI/BottomSheet/BottomSheet';

interface PhonesBottomSheetProps {
  isOpen: boolean;
  close: () => void;
  phones?: string[];
}

export const PhonesBottomSheet: React.FC<PhonesBottomSheetProps> = ({
  isOpen,
  close,
  phones,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  if (!phones?.length) return null;

  return (
    <BottomSheet
      dataTestId="phones-bottom-sheet"
      isOpen={isOpen}
      close={close}
      title={t('common.call')}
      isInPortal
    >
      {phones.map(item => {
        const href = `tel:${cleanPhoneNumber(item)}`;
        return (
          <S.PhoneNumber key={item} href={href}>
            <PhoneIcon fill={theme.palette.primary.labels} />
            {item}
          </S.PhoneNumber>
        );
      })}
    </BottomSheet>
  );
};
